export const skuAttributes = (sku) => Object.fromEntries(
  (sku?.ae_sku_property_dtos?.ae_sku_property_d_t_o || [])
    .map((prop) => [String(prop.sku_property_name || "").trim(), String(prop.property_value_definition_name || prop.sku_property_value || "").trim()])
    .filter(([name, value]) => name && value)
);

export const skuStock = (sku) => Math.max(0, Number(sku?.sku_available_stock) || 0);
export const skuMatches = (sku, attributes) => {
  const values = skuAttributes(sku);
  return Object.entries(attributes || {}).every(([key, value]) => values[key] === String(value));
};

// Keep as many other choices as possible while allowing a shopper to move
// between valid combinations such as Red/Small and Blue/Large.
export const selectSkuForOption = (skus, attributes, name, value) => {
  const candidates = (Array.isArray(skus) ? skus : []).filter((sku) =>
    skuStock(sku) > 0 && skuMatches(sku, { [name]: value })
  );
  const score = (sku) => Object.entries(attributes || {})
    .filter(([key, val]) => key !== name && skuMatches(sku, { [key]: val })).length;
  return candidates.sort((a, b) => score(b) - score(a))[0] || null;
};
